import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { toast } from 'sonner';
import { CheckCircle } from 'lucide-react';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

const Registration = () => {
  const [events, setEvents] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    event_id: '',
    event_name: '',
    category: 'student',
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await axios.get(`${API}/events`);
      setEvents(response.data);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'event_id') {
      const selectedEvent = events.find(event => event.id === value);
      setFormData({
        ...formData,
        event_id: value,
        event_name: selectedEvent ? selectedEvent.name : '',
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`http://3.109.108.187/api/registrations`, formData);
      toast.success('Registration successful! We will contact you soon.');
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        event_id: '',
        event_name: '',
        category: 'student',
      });
    } catch (error) {
      console.error('Error submitting registration:', error);
      toast.error('Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-green-50" data-testid="registration-page">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[300px] mt-20" data-testid="registration-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-green-600"></div>
        <div className="relative h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">Event Registration</h1>
            <p className="text-xl text-white/90">Join us in celebrating 75 years of excellence</p>
          </div>
        </div>
      </section>

      {/* Registration Form */}
      <section className="section-spacing" data-testid="registration-form-section">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          {submitted ? (
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center zoom-in" data-testid="registration-success">
              <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
                <CheckCircle size={40} className="text-green-600" />
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-4">Registration Successful!</h2>
              <p className="text-lg text-gray-600 mb-8">
                Thank you for registering. We will contact you soon with further details.
              </p>
              <button
                onClick={() => setSubmitted(false)}
                data-testid="register-another-btn"
                className="btn-primary"
              >
                Register for Another Event
              </button>
            </div>
          ) : (
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-testid="registration-form">
              <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
                Register <span className="text-gradient">Now</span>
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    data-testid="registration-name-input"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                    placeholder="Enter your full name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    data-testid="registration-email-input"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                    placeholder="your.email@example.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    data-testid="registration-phone-input"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                    placeholder="+91 1234567890"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Select Event *</label>
                  <select
                    name="event_id"
                    value={formData.event_id}
                    onChange={handleChange}
                    required
                    data-testid="registration-event-select"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  >
                    <option value="">Choose an event</option>
                    {events.map((event) => (
                      <option key={event.id} value={event.id}>
                        {event.name} - {event.date}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Category *</label>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                    data-testid="registration-category-select"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  >
                    <option value="student">Student</option>
                    <option value="alumni">Alumni</option>
                    <option value="faculty">Faculty</option>
                    <option value="guest">Guest</option>
                  </select>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  data-testid="registration-submit-btn"
                  className="w-full btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? 'Submitting...' : 'Register Now'}
                </button>
              </form>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Registration;